window.checkIfCatalogSelected = function checkIfCatalogSelected() {
  if ($('#listing_cat_matches_select').hasClass('current_tab')) {
    const searchParams = window.merchantos.utils.getQueryParams(window.location.search);
    const pageContext = searchParams.name;
    window.Analytics.track('Searched Legacy Catalog', { pageContext });
  }
};

window.merchantos.asyncSubscribe.subscribeToFormCall(
  'listing.refresh',
  window.checkIfCatalogSelected
);

$(() => window.checkIfCatalogSelected());

$(window).on('hashchange', () => window.checkIfCatalogSelected());
